import MUIDialogTitle from '@mui/material/DialogTitle'

export const DialogTitle = MUIDialogTitle
